import { useMemo } from 'react';

import dynamic from 'next/dynamic';
import styled from 'styled-components';
import { useParams } from 'next/navigation';

import Breadcrumb from '@components/Breadcrumb/Breadcrumb';
import { BreadCrumbListSchemaOrg } from '@utils/schemaorg/BreadCrumbListSchemaOrg';
import { useDevice } from '@contexts/device';

import { SideBarType, useSideBarContentsQuery } from '../../hooks';

const MobileContentMenu = dynamic(() => import('./MobileContentMenu'));
const SideMenu = dynamic(() => import('./SideMenu'));

const MainPageBreadCrumbData = { title: 'Ana Sayfa', url: '/' };

const BreadCrumbContainer = styled.div`
  grid-area: breadCrumb;
  margin-top: 50px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    padding-left: 10px;
    margin-top: 15px;
    margin-bottom: 10px;
    max-width: 100vw;
  }
`;

const MenuContainer = styled.div`
  grid-area: menu;
  max-width: 100vw;
`;

const ContentMenu = ({ type }: { type: SideBarType }) => {
  // const { slug: urlSlug = '' } = useQueryParams();
  const params = useParams();
  const { slug: urlSlug = '' } = params as Record<string, string>;
  const { data: { items = [] } = {} } = useSideBarContentsQuery({
    type,
  });

  const { isMobile } = useDevice();
  const breadCrumbData = useMemo(() => {
    let computed: Array<typeof MainPageBreadCrumbData> = [];
    if (items.length && urlSlug) {
      items.forEach(({ title = '', slug, links }) => {
        if ('/' + urlSlug === slug) {
          computed = [MainPageBreadCrumbData, { title, url: slug }];
        }
        links.forEach(({ name = '', href }) => {
          if ('/' + urlSlug === href) {
            computed = [
              MainPageBreadCrumbData,
              { title, url: '' },
              { title: name, url: href },
            ];
          }
        });
      });
    }
    return computed;
  }, [items, urlSlug]);

  const staticPageSubPath = type === 'corporate' ? '/kurumsal' : '/siteler';
  const defaultSelectedKeys =
    breadCrumbData.length > 0
      ? [breadCrumbData[breadCrumbData.length - 1].title]
      : [];
  const defaultOpenKeys =
    breadCrumbData.length === 3 ? [breadCrumbData[1].title] : [];

  return (
    <>
      <BreadCrumbContainer>
        {breadCrumbData && breadCrumbData.length ? (
          <BreadCrumbListSchemaOrg data={breadCrumbData} />
        ) : null}
        <Breadcrumb items={breadCrumbData || []} />
      </BreadCrumbContainer>
      <MenuContainer>
        {isMobile ? (
          <MobileContentMenu
            items={items}
            // onMenuItemClick={onMenuItemClick}
            pageName={breadCrumbData?.[breadCrumbData?.length - 1]?.title}
            staticPageSubPath={staticPageSubPath}
            drawerTitle={type === 'corporate' ? 'Kurumsal' : 'Siteler'}
            defaultSelectedKeys={defaultSelectedKeys}
            defaultOpenKeys={defaultOpenKeys}
          />
        ) : (
          <SideMenu
            items={items}
            staticPageSubPath={staticPageSubPath}
            defaultSelectedKeys={defaultSelectedKeys}
            defaultOpenKeys={defaultOpenKeys}
          />
        )}
      </MenuContainer>
    </>
  );
};

export default ContentMenu;
